// test1142
(1142 && 0);
